import dropWhile from './dropWhile';
import flatten from './flatten';
import groupBy from './groupBy';
import interleave from './interleave';
import modZip from './modZip';
import partition from './partition';
import takeWhile from './takeWhile';

export default {
  dropWhile,
  flatten,
  groupBy,
  interleave,
  modZip,
  partition,
  takeWhile,
};



// WEBPACK FOOTER //
// ./app/utils/array/index.js